export function formatNumber(num: number) {
   return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export function capitalizeFirstLetter(text: string) {
   return text?.charAt(0).toUpperCase() + text?.slice(1);
}
 